const LOCAL_HOSTNAMES = ["localhost", "127.0.0.1", "[::1]", "0.0.0.0"];
function isLocalUrl(url) {
  try {
    const { hostname } = new URL(url);
    return LOCAL_HOSTNAMES.includes(hostname);
  } catch {
    return true;
  }
}
export {
  isLocalUrl
};
//# sourceMappingURL=is-local-url.js.map
